import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

export enum DataDogSeverityLevel {
  Debug = 'Debug',
  Warning = 'Warning',
  Information = 'Information',
  Error = 'Error',
  Critical = 'Critical'
}

const DEBUG_TRACKING = import.meta.env.VITE_DEBUG_TRACKING === 'true' || import.meta.env.DEV;

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: 'us3.datadoghq.com',
  service: import.meta.env.VITE_DATADOG_SERVICE,
  env: import.meta.env.VITE_DATADOG_ENV,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  plugins: [reactPlugin()],
  allowedTracingUrls: [import.meta.env.VITE_CONTENT_DELIVERY_API],
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true
});

if (DEBUG_TRACKING) {
  // eslint-disable-next-line no-console
  console.log('📊 [DatadogService] RUM initialized');
}

datadogRum.startSessionReplayRecording();

export { datadogRum };
